import React, {FC, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {Tooltip, Whisper} from 'rsuite'

interface CopyToClipboardProps {
  text: string;
}

const CopyToClipboard: FC<CopyToClipboardProps> = ({text}) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (error) {
      console.error('Failed to copy text: ', error)
    }
  }

  return (
    <Whisper placement="topEnd" controlId="control-id-hover" trigger="hover"
             speaker={<Tooltip>{!copied ? 'Copier' : 'Copié'}</Tooltip>}>
      <div onClick={handleCopy} className="cursor-pointer">
        <div className="notice d-flex bg-light-info rounded px-3 py-1">
          <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
            <div className="mb-3 mb-md-0 fw-bold">
              <span className="fs-7 text-gray-800">{text}</span>
            </div>

            <div className="btn btn-icon w-30px h-30px w-md-40px h-md-40px"
                 onClick={handleCopy}
            >
              {
                !copied
                  ? <KTSVG path="/media/icons/duotune/general/gen054.svg" className="svg-icon-2 svg-icon-primary" />
                  : <KTSVG path="/media/icons/duotune/general/gen037.svg" className="svg-icon-1 svg-icon-success" />
              }

            </div>
          </div>
        </div>
      </div>
    </Whisper>
  )
}

export {CopyToClipboard}